/* src/app/front-layout/key-dates/key-dates.component.css */
.kd-hero {
  background-image: url(/assets/images/kd-bg.png);
  background-size: cover;
  background-position: center;
  height: 50vh;
  margin-top: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
}
.kd-hero h1 {
  font-size: 64px;
  margin-bottom: 20px;
  color: white;
  font-weight: 600;
}
.kd-hero h2 {
  font-size: 32px;
  margin-bottom: 20px;
  color: #ffffff;
  font-weight: 400;
}
.dates-container {
  width: 80%;
  margin: 20px auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dates-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
}
.dates-content p {
  font-size: 22px;
  color: #0077b6;
  margin-bottom: 20px;
}
.dates-content ul {
  list-style: disc;
  list-style-position: inside;
  padding: 0;
  margin: 0;
}
.dates-content li {
  font-size: 18px;
  color: #333;
  margin-bottom: 16px;
}
@media (max-width: 768px) {
  .kd-hero {
    height: 30vh;
    padding: 20px;
  }
  .kd-hero h1 {
    margin-top: 100px;
    font-size: 32px;
    margin-bottom: 10px;
    line-height: 1.2;
  }
  .kd-hero h2 {
    font-size: 18px;
    margin-bottom: 10px;
    line-height: 1.3;
  }
  .dates-container {
    width: 95%;
    margin: 10px auto;
    padding: 10px;
  }
  .dates-content {
    padding: 15px 10px;
  }
  .dates-content h2 {
    font-size: 24px;
    margin-bottom: 10px;
  }
  .dates-content p {
    font-size: 16px;
    margin-bottom: 15px;
    line-height: 1.4;
  }
  .dates-content ul {
    padding-left: 5px;
  }
  .dates-content li {
    font-size: 15px;
    margin-bottom: 12px;
    line-height: 1.4;
    padding-left: 15px;
    text-indent: -15px;
  }
}
@media (max-width: 480px) {
  .kd-hero h1 {
    font-size: 28px;
  }
  .kd-hero h2 {
    font-size: 16px;
  }
  .dates-content p {
    font-size: 15px;
  }
  .dates-content li {
    font-size: 14px;
    margin-bottom: 10px;
  }
}
/*# sourceMappingURL=key-dates.component.css.map */
